// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-markdown-template-tsx": () => import("./../../../src/templates/markdownTemplate.tsx" /* webpackChunkName: "component---src-templates-markdown-template-tsx" */)
}

